import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { FileUploadListResponse, FileUploadResponse } from 'api/Responses/OrderResponses';
import { useLanguage } from 'context/AppContext';
import FileUploadListItem from './FileUploadListItem';

interface FileUploadListProps {
  data: FileUploadListResponse[];
  handleDuplicates: (response: FileUploadResponse) => void;
}

const FileUploadList: React.FC<FileUploadListProps> = ({ data, handleDuplicates }) => {
  const [language] = useLanguage();

  const handleListDuplicates = (response: FileUploadResponse): void => {
    handleDuplicates(response);
  };

  return (
    <Table sx={{ maxHeight: 'auto' }}>
      <TableHead>
        <TableRow>
          <TableCell>{language.DeliveryPortal.FileUploadListTable.status}</TableCell>
          <TableCell>{language.DeliveryPortal.FileUploadListTable.fileName}</TableCell>
          <TableCell>{language.DeliveryPortal.FileUploadListTable.uploader}</TableCell>
          <TableCell align="center">{language.DeliveryPortal.FileUploadListTable.date}</TableCell>
          <TableCell align="center">{language.DeliveryPortal.FileUploadListTable.totalDeliveries}</TableCell>
          <TableCell align="center" size="small">
            {language.DeliveryPortal.FileUploadListTable.download}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.length ? (
          data.map(file => {
            return <FileUploadListItem file={file} key={file.upload_id} handleListDuplicates={handleListDuplicates} />;
          })
        ) : (
          <TableRow>
            <TableCell align="center" colSpan={5}>
              <Typography>{language.DeliveryPortal.FileUploadListTable.noResults}</Typography>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default FileUploadList;
